import { useTranslation } from 'react-i18next'

import { TextAreaFormField } from '@/components/form/text-area-form-field'
import { TextInputFormField } from '@/components/form/text-input-form-field'

import {
  NOTE_DESCRIPTION_MAX_LENGTH,
  NOTE_NAME_MAX_LENGTH,
} from './time-block-notes-modal.constants'

export const TimeBlockNoteForm = () => {
  const { t } = useTranslation(['reservations'])

  return (
    <>
      <TextInputFormField
        required
        characterLimit={NOTE_NAME_MAX_LENGTH}
        label={t('reservations:timeBlocks.notesModal.form.title.label')}
        maxLength={NOTE_NAME_MAX_LENGTH}
        name="title"
        placeholder={t('reservations:timeBlocks.notesModal.form.title.placeholder')}
      />
      <TextAreaFormField
        required
        label={t('reservations:timeBlocks.notesModal.form.noteBody.label')}
        maxLength={NOTE_DESCRIPTION_MAX_LENGTH}
        name="noteBody"
        placeholder={t('reservations:timeBlocks.notesModal.form.noteBody.placeholder')}
        rows={5}
      />
    </>
  )
}
